import React from "react";

const TableHeading = ({children}) => {
    return (
        <>
            <style>{`
                .table-heading {
                   padding-top: 12px;
                    padding-right: 16px;
                    padding-bottom: 12px;
                    padding-left: 8px;
                    text-align: left;
                    font-size: 0.75rem;
                    font-weight: 500;
                    color: #6B7280; /* Tailwind's gray-500 */
                    text-transform: uppercase;
                    letter-spacing: 0.05em;
                }
            `}</style>
            <th scope="col" className="table-heading">
                {children}
            </th>
        </>
    );
};

export default TableHeading;
